import React, { useState } from 'react';
import { Form, InputGroup, Nav } from 'react-bootstrap';
import IconSearch from '../../../assets/SidebarIcons/icon-search.svg';
import ActionItem from './ActionItem';
import { useDispatch } from "react-redux";
import { reloadContactList } from "../../../store/actions/reduxAction";

const ContactList = (props) => {
  const dispatch = useDispatch();
  const { contactList, setLeadListId, setSearchTags, handleEdit, handleDelete, handleExport, handleCustomField } = props;
  const [onFocus, setOnFocus] = useState(false);
  const [searchContactsQuery, setSearchContactsQuery] = useState('');
  const [contactID, setContactID] = useState(0);

  const handleItemClick = (name, id, tags) => {
    setSearchTags(tags);
    setLeadListId(id);
    setContactID(id);
    dispatch(reloadContactList());
  };

  const handleSearchContacts = event => {
    setSearchContactsQuery(event.target.value);
  };

  const filteredContactList = contactList.filter(contact =>
    contact.name.toLowerCase().includes(searchContactsQuery.toLowerCase())
  );

  const handleFormSubmit = event => {
    event.preventDefault();
  };

  return (
    <>
      <Form onSubmit={handleFormSubmit}>
        <Form.Group>
          <InputGroup className={onFocus ? 'on-focus' : ''}>
            <InputGroup.Text style={{ background: '#f5f7fa' }}>
              <img alt="..." src={IconSearch} />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search"
              value={searchContactsQuery}
              onChange={handleSearchContacts}
              onFocus={() => setOnFocus(true)}
              onBlur={() => setOnFocus(false)}
            />
          </InputGroup>
        </Form.Group>
      </Form>
      <div className="tab-wrapper">
        <Nav as="ul" className="flex-column">
          {filteredContactList.map((contact) => (
            <ActionItem
              key={contact.id}
              id={contact.id}
              name={contact.name}
              count={contact.count}
              tags={contact.tags}
              type="Contact List"
              className={contact.id === contactID ? 'active' : ''}
              handleEdit={() => handleEdit(contact)}
              handleItemClick={handleItemClick}
              handleDelete={() => handleDelete(contact)}
              handleExport={() => handleExport(contact)}
            />
          ))}
        </Nav>
      </div>
    </>
  );
};

export default ContactList;
